<template>
    <tr>
        <td>
            <c-checkbox
                class="c-form-checkbox--small"
                v-model="selected"
                :value="translator.opdrachtnemer.id"
                :disabled="selected == false && value.length == max"></c-checkbox>
        </td>
        <td class="color-dark-gray">{{translator.opdrachtnemer.user.name}}</td>
        <td class="color-dark-gray">{{translator.registerniveau.naam}}</td>
        <td class="color-dark-gray" >{{translator.opdrachtnemer.kan_zichzelf_reviseren ? 'Reviseert zelf' : 'Reviseert zelf niet'}}</td>
        <td>

            <span v-for="(solidStar, index) in rating" :key="index">
                <svg v-if="solidStar" class="color-warning" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M17.5615 20.955a.9958.9958 0 0 1-.463-.113l-5.099-2.664-5.099 2.664a.9978.9978 0 0 1-1.051-.079 1.0003 1.0003 0 0 1-.397-.978l.972-5.628-4.12-3.985a.9982.9982 0 0 1-.256-1.026c.116-.363.43-.627.807-.682l5.701-.828 2.547-5.126c.338-.68 1.454-.68 1.792 0l2.547 5.126 5.701.828c.377.055.691.319.807.682.117.363.019.761-.256 1.026l-4.12 3.985.972 5.628c.064.375-.089.754-.397.978a.987.987 0 0 1-.588.192" id="starfull"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#starfull"/></svg>
                <svg v-else class="color-dark-gray" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M11.9995 16.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157a.9986.9986 0 0 1 .29-.889l3.036-2.936-4.203-.612a.9985.9985 0 0 1-.752-.544l-1.886-3.794-1.886 3.794a.9985.9985 0 0 1-.752.544l-4.203.612 3.036 2.936c.238.231.347.563.29.889l-.717 4.157 3.769-1.97c.145-.075.304-.113.463-.113m5.562 4.905a.9958.9958 0 0 1-.463-.113l-5.099-2.664-5.099 2.664a.9978.9978 0 0 1-1.051-.079 1.0003 1.0003 0 0 1-.397-.978l.972-5.628-4.12-3.985a.9982.9982 0 0 1-.256-1.026c.116-.363.43-.627.807-.682l5.701-.828 2.547-5.126c.338-.68 1.454-.68 1.792 0l2.547 5.126 5.701.828c.377.055.691.319.807.682.117.363.019.761-.256 1.026l-4.12 3.985.972 5.628c.064.375-.089.754-.397.978a.987.987 0 0 1-.588.192" id="star"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#star"/></svg>
            </span>

        </td>
    </tr>
</template>

<script>
import CCheckbox from '@components/form/Checkbox';

export default {
    components: { CCheckbox },
    props: {
        translator: {
            required: true
        },
        value: {
            required: true
        },
        max: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            selected: false,
            rating: Array(5).fill(false).fill(true, 0, this.translator.opdrachtnemer.waardering)
        }
    },
    watch: {
        selected() {

            let selected = [ ...this.value ];
            let index = selected.findIndex( s => s == this.translator.opdrachtnemer.id );

            if ( this.selected ) {

                if ( index < 0 ){
                    selected.push(this.translator.opdrachtnemer.id);
                    this.$emit('input', selected);
                }
            }
            else {
                if ( index >= 0 ) {
                    selected.splice(index, 1);
                    this.$emit('input', selected);
                }
            }
        }
    },
    method: {
        getRegistrationLevel(id) {

        }
    },
    created() {

        if ( this.value.indexOf(this.translator.opdrachtnemer.id) >= 0 ) {
            this.selected = true;
        }
    }
}
</script>
